import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiLinearProgress-root": {
      height: 5,
      width: 75,
      borderRadius: 5,
      background: "#DCDEE9",
    },
  },
  inProgress: {
    "& .MuiLinearProgress-bar": {
      background:
        "transparent linear-gradient(268deg, #25B9F4 0%, #08519C 100%) 0% 0% no-repeat padding-box",
    },
  },
  overdue: {
    "& .MuiLinearProgress-bar": {
      background:
        "#F75A5A",
    },
  },
  completed: {
    "& .MuiLinearProgress-bar": {
      background:
        "#15C473",
    },
  },
}));

export default useStyles;
